import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PolicyQuery} from 'src/app/modules/policy/state/policy.query';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions} from '../question-helper';
import {QuestionFlowSessionStore} from '../state/question-flow-session.store';

@Component({
    selector: 'app-question-product-select',
    templateUrl: './question-product-select.component.html',
    styleUrls: ['./question-product-select.component.scss'],
    standalone: false
})
export class QuestionProductSelectComponent implements OnInit {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() editModal = false;
  @Output() questionAnswer = new EventEmitter();
  @Output() navigateBack = new EventEmitter();

  categories: any[] = [];
  policies: any[] = [];
  isCategory = false;
  uniqueControlName = `products-name-${newGuid()}`;
  parameter: any;

  constructor(
    private policyQuery: PolicyQuery,
    private questionFlowSessionStore: QuestionFlowSessionStore
  ) {
  }

  ngOnInit(): void {
    this.policies = [];
    if (this.question.question_prompt === 'policies') {
      this.isCategory = false;
      this.policies = parseOptions(this.question.options);
    } else if (this.question.question_prompt === 'categories' || this.question.question_prompt === 'products') {
      this.isCategory = true;
      this.categories = parseOptions(this.question.options);
    }
    
    try {
      this.parameter = this.question.parameter ? JSON.parse(this.question.parameter) : [];
    } catch {
      this.parameter = [];
    }
    this.readOnly = Array.isArray(this.parameter) &&
      this.parameter.some(p => p.parameter === 'readOnly' && p.value === '1') &&
      !!this.question?.answer;
      console.log(this.readOnly,this.editModal);
  }

  getProductCategories(): any {
    const groupsDict: {} = this.categories.reduce((r: any, a: any) => {
      r[a.product_category] = [...r[a.product_category] || [], a];
      return r;
    }, {});

    const groupArray = Object.entries(groupsDict);
    const categories = [];
    groupArray?.forEach((item: any) => {
      categories.push(item[0]);
    });
    return categories;
  }

  getProducts(category: any): any {
    return this.categories.filter((product: any) => product.product_category === category);
  }

  selectOption(option: any, o: any = null): void {
    this.question.answer = option;
    console.log('selected option', option, o);
    let selectedCategory = o?.category_id;
    if (selectedCategory) {
      this.questionFlowSessionStore.update({category_id: selectedCategory});
    }
    if (this.isCategory) {
      selectedCategory = this.categories.find((category: any) => category.product_category_id === option);
      if (selectedCategory) {
        this.questionFlowSessionStore.update({category_id: selectedCategory.product_category_id, css: selectedCategory.css});
      }
    }
    this.questionAnswer.emit(this.question);
  }

  goToPreviousQuestion(): void {
    this.navigateBack.emit(true);
  }

  parseJSON(ratings: any): any {
    if (ratings){
      return JSON.parse(ratings);
    }
    else{
      return [];
    }

  }
  getCategoryName(id: string): string {
    return this.categories.find((category: any) => category.product_category_id == id)?.category_name || 'N/A';
  }

}
